<template>
  <el-table-column label="Számlán szereplő összegek">
    <el-table-column
      prop="net_price"
      sortable="custom"
      label="Nettó ár"
      show-overflow-tooltip
      min-width="130"
    >
      <template slot-scope="scope">
        {{ scope.row.net_price | currency }}
      </template>
    </el-table-column>
    <el-table-column
      prop="vat_value"
      sortable="custom"
      label="ÁFA összeg"
      show-overflow-tooltip
      min-width="130"
    >
      <template slot-scope="scope">
        <div v-if="scope.row.vat_value">
          {{ scope.row.vat_value | currency }}
        </div>
      </template>
    </el-table-column>
    <el-table-column
      prop="gross_price"
      sortable="custom"
      label="Bruttó ár"
      show-overflow-tooltip
      min-width="150"
    >
      <template slot-scope="scope">
        {{ scope.row.gross_price | currency }}
      </template>
    </el-table-column>
    <el-table-column
      prop="currency_code"
      sortable="custom"
      label="Deviza"
      show-overflow-tooltip
      min-width="90"
    >
      <template slot-scope="scope">
        {{ scope.row.currency_code }}
      </template>
    </el-table-column>
  </el-table-column>
</template>

<script>
export default {
  propName: 'net_price',
};
</script>
